<!-- Custom SVG definitions for icons not included in the styleguide -->
<svg width="0" height="0" style="position:absolute">
	<symbol *ngFor="let icon of icons" [attr.viewBox]="icon.viewBox" [attr.id]="icon.id" xmlns="http://www.w3.org/2000/svg">
		<path fill="inherit" [attr.d]="icon.path"></path>
	</symbol>
</svg>
